import { render } from "./SectionTeacherTopList.vue?vue&type=template&id=0aa2bcba"
import script from "./SectionTeacherTopList.vue?vue&type=script&lang=js"
export * from "./SectionTeacherTopList.vue?vue&type=script&lang=js"

import "./SectionTeacherTopList.vue?vue&type=style&index=0&id=0aa2bcba&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__